// U1b-FE — pure nav-item visibility predicate, extracted from Layout so the
// gating logic is unit-testable without rendering the whole shell.
import type { User } from "@/types";

/** P5 — true if the user holds the given S4 permission key. Default-safe:
 *  a missing permissions array is treated as no permissions. */
export function hasPermission(user: User | null, key: string): boolean {
  return user?.permissions?.includes(key) ?? false;
}

export interface NavGate {
  adminOnly?: boolean;
  auditorOk?: boolean;
  superAdminOnly?: boolean;
  /** When set, the item is hidden unless the user holds this S4 permission
   *  key (from /auth/me). Additive to the legacy flags above. */
  requiredPermission?: string;
}

export interface NavVisibilityCtx {
  role: string | undefined;
  isSuperAdmin: boolean;
  user: User | null;
}

/** Visibility = superAdminOnly + adminOnly legacy flags AND the
 *  permission-derived requiredPermission gate. */
export function navItemVisible(item: NavGate, ctx: NavVisibilityCtx): boolean {
  if (item.superAdminOnly && !ctx.isSuperAdmin) return false;
  if (item.adminOnly) {
    const allowed =
      ctx.role === "admin" || (!!item.auditorOk && ctx.role === "auditor");
    if (!allowed) return false;
  }
  if (
    item.requiredPermission &&
    !hasPermission(ctx.user, item.requiredPermission)
  ) {
    return false;
  }
  return true;
}
